if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.common = {
  init: function () {
    document.documentElement.className += (("ontouchstart" in document.documentElement) ? ' touch' : ' no-touch');

    $('body').on('click', '.plus-minus .minus', function (e) {
      e.preventDefault();
      var box = $(this).parent().find('input');
      if(parseInt(box.val()) >1) box.val(parseInt(box.val())-1);
      box.trigger('change');
    });
    $('body').on('click', '.plus-minus .plus', function (e) {
      e.preventDefault();
      var box = $(this).parent().find('input');
      box.val(parseInt(box.val())+1);
      box.trigger('change');
    });

    $( '.ac-title:not(.active)').each(function(){
      $(this).next().css('display','none');
    });

    $('body').on('click', '.ac-title', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if ($(this).hasClass('active')) {
        $(this).next().removeClass('active');
        $(this).next().slideUp();
      }
      else {
        if($(this).parents('.singles').length)
        {
          $('.singles').find('.ac-title.active').next().slideUp();
          $('.singles .active').removeClass('active');
        }
        $(this).next().addClass('active');
        $(this).next().slideDown();
      }
      $(this).toggleClass('active');
    });

    //section custom
    $('[data-custom-class]').each(function () {
      $(this).parent().addClass($(this).attr('data-custom-class'));
    });

    //window scrolls

    var scrollpos = 0;
    var scrollTimeout;
    var throttle = 200;

    $(window).on('scroll', function () {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(function () {
          var goindown = window.pageYOffset > scrollpos ? true : false;
          scrollpos = window.pageYOffset;
          $(window).trigger('utiscroll', [window.pageYOffset, goindown]);
          scrollTimeout = null;
        }, throttle);
      }
      //var goindown = window.pageYOffset>scrollpos?true:false;
      //scrollpos = window.pageYOffset;
      //$(window).trigger('utiscroll', [window.pageYOffset, goindown]);
    });

    //video change
    $(window).resize(function () {
      if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
        UTI.isdesktop = true;
        $(window).trigger('uti-device-changed');
      }
      else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
        UTI.isdesktop = false;
        $(window).trigger('uti-device-changed');
      }
      setminsize();

    });

    $(window).on('uti-device-changed', function () {
      UTI.common.loadmpfors();
    });

    UTI.common.loadmpfors();

    //same height for each objects

    setminsize();

    function setminsize()
    {
      $('[data-set-minh]').each(function(){
        var daarr =  $(this).attr('data-set-minh').split(',');
        for (var i = 0; i < daarr.length; i++) {
          setmin($(this).find(daarr[i]));
        }
      });
    }

    function setmin(item)
    {
      item.height('');
      var titmemaxh = Math.max.apply(null, item.map(function ()
      { return $(this).height();}).get());
      item.height(titmemaxh);
    }

  }, loadmpfors: function () {
    var newmp4 = $('.hero-sou').attr('data-m');
    if (UTI.isdesktop) {
      newmp4 = $('.hero-sou').attr('data-d');
    }
    var videocontainer = $('.hero-vid');
    var videosource = $('.hero-sou');

    if (videocontainer.length) {
      videocontainer.get(0).pause();
      videosource.get(0).setAttribute('src', newmp4);
      videocontainer.get(0).load();
      //videocontainer.setAttribute('poster', newposter); //Changes video poster image
      videocontainer.get(0).play();
    }
  }

};



$(function () {
  if ((jQuery(window).width() > 749) && !UTI.isdesktop) {
    UTI.isdesktop = true;
    $(window).trigger('uti-device-changed');
  }
  else if ((jQuery(window).width() < 750) && UTI.isdesktop) {
    UTI.isdesktop = false;
    $(window).trigger('uti-device-changed');
  }
  UTI.common.init();
});

//header
jQuery(document).ready(function() {

  //mobile nav open
  PROJ.ajaxcart.init();
  UTI.pdp.init();

  $('body').on('click', '.burger', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html, body').toggleClass('boxed mobnav');
  });

  $('body').on('click', '.nav-mob-wrapper .close-tab', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html').removeClass('boxed').removeClass('mobnav');
    $('body').removeClass('boxed').removeClass('mobnav');
  });

  $('body').on('click', '.desk-search.set', function (e) {
    e.preventDefault();
    $('.desk-search-wrap').slideToggle();
  });

  $('body').on('click', '.mobile-nav .roll-nav .first-link', function (e) {
    e.preventDefault();
    $(this).next().slideToggle();
    $(this).toggleClass('active-plus');
  });


  ///////////////////

  $('.mainnavi-mob .first-ul .level1 > a').click(function(e)
  {
    e.stopPropagation();
    e.preventDefault();
    $(this).parent().toggleClass('closed');

  });

  $(window).on('utiscroll',function(a,b,c){
    if(c)
    {
      $('body').addClass('scroll-down');
    }
    else
    {
      $('body').removeClass('scroll-down');
    }
    if(a)
    {
      $('body').addClass('scrolled');
    }
    else
    {
      $('body').removeClass('scrolled');
    }
  });

});

//pdp

var UTI = (typeof UTI === 'object') ? UTI : {};

UTI.pdp = {
  init: function () {
    var _this = this;
    $('body').on('click', '.product-form .variable',function (e){
      e.preventDefault();
      if($(this).hasClass('active')) return;
      var thisform = $(this).parents('.product-form');
      var thisid = $(this).attr('varid');

      thisform.find('.variable').removeClass('active');
      $(this).addClass('active');
      window.history.replaceState({ }, '', '?variant='+thisid);

      var varprice = $(this).parent().find('.var-price').html();
      thisform.find('.price-replace').html(varprice);
      thisform.find('form input[name="id"]').val(thisid);

      if($(this).hasClass('available'))
      {
        thisform.find('button').removeAttr('disabled');
      }else
      {
        thisform.find('button').attr('disabled','');
      }
      if($(this).attr('data-imgvar-id') != "")
      {
        var ind = $('[data-assign-var="'+$(this).attr('data-imgvar-id')+'"]').index();
        $('.acc-gal').find('.gallery-inside').flickity( 'select', ind );
        if($(this).parents('.pro-item-add').length)
        {
          $(this).parents('.pro-item-add').find('.varimage img').removeAttr('srcset');
          $(this).parents('.pro-item-add').find('.varimage img').attr('src',$(this).attr('data-vimage') );
        }
      }
    });
  }
};

"use strict"
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.ajaxcart = {
  VAR: {},

  init: function () {
    var _this = this;

    setTimeout(function(){
      _this.animateCart();
    },100);

    if (window.location.href.indexOf("minicart=true") > -1) {
      $('body,html').addClass('mini-cart');
      setTimeout(function(){
        $('body,html').addClass('mini-cart-ani');
      },500);
    }

    $('body').on('click', '.nav-close-cart, .minicart-back', function (e) {
      e.preventDefault();
      _this.closecart();
    });

    $('body').on('click tap', 'a.mini_cart, .opencart,[href="/cart"]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this.opencart();
    });

    $('body').on('click', '[data-varid]', function (e) {
      e.preventDefault();
      var varid = $(this).attr('data-varid');
      $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
      $(this).parents('.cross-slide').find('.money').text('Only '+$(this).attr('data-varprice') );
      $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
      $(this).addClass('active');
    });

    $('body').on('change', '.cart-item [data-proid].qty-input', function (e) {
      e.preventDefault();
      var ids = $(this).attr('data-proid');
      var qty = $(this).val();
      _this.updateItem(ids, qty);
      setTimeout(function(){
        if($('body').hasClass('template-cart'))
        {
          location.reload(true);
        }
      },500);
    });

    $('body').on('click', '[data-directadd]', function (e) {
      e.preventDefault();
      _this.addItem($(this).attr('data-directadd'));
    });

    //reove from mini cart
    $('body').on('click', '.incart .remove', function (e) {
      e.preventDefault();
      var par = $(this).parents('.incart');
      var qty = 0;
      _this.updateItem(par.attr('data-proid'), qty);
    });

    var cform;
    $('body').on('submit', 'form[action="/cart/add"]', (function (e) {
      cform = $(this);
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $('.cart-btn button');
      $('#mini-cart').addClass('loading');

      $addToCartBtn.addClass('disabled').prop('disabled', true);

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function (itemData) {

          Shopify.getCart(function(cart){

            if(cform.parents('[data-upsell-redirect]').length)
            {
              _this.updateCart();
              _this.loadExternalPage(cform.parents('[data-upsell-redirect]').attr('data-upsell-redirect'));
            }else
            {
              _this.updateCart();
              $addToCartBtn.removeClass('disabled').prop('disabled', false);
              $('body').removeClass('hidetop');
              _this.opencart();
            }
            if ( $.isFunction(window.addedToCartKlaviyo)) {
              addedToCartKlaviyo();
            }

          }.bind(this));

        },
        error: function (XMLHttpRequest) {
          _this.updateCart();
        }
      });
      return false;

    }));

    $('body').on('click','.close-cart-note', function (e) {
      e.preventDefault();
      $('.cart-note-wrap').toggleClass('cartnote');
    });

    $('body').on('click','.cart-note-btn', function (e) {
      var dataToSend = "note="+encodeURIComponent($('#cart-note').val());
      $('.cart-note-wrap').removeClass('cartnote');
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        // data: "{note="+ +"}",
        data: dataToSend ,
        dataType: "json",
        success: function(e) {
        },
        error: function(e, t) {
        },
        complete: function() {
        }
      });
    });
    _this.scrollbarmob();

//shipping protection
    $('body').on('click', '[data-protection-id]', function (e) {
      e.preventDefault();
      if($(this).hasClass('active'))
      {
        sessionStorage.setItem('noprotection',true);
        _this.updateItem($(this).attr('data-protection-id'), 0);
      }else
      {
        sessionStorage.clear('noprotection');
        _this.addItem($(this).attr('data-protection-id'));
      }
    });

    setTimeout(function(){
    $('.cross-wrap').flickity({
      "pageDots": false, "contain": true, prevNextButtons: true,
    });},1000);


  },loadExternalPage:function(page){
    $('body,html').removeClass('mini-cart');
    $.get(page,function(data){
      $('#MainContent').html($(data).find('section.shopify-section'));
      $('body,html').removeClass('mini-cart');
    }).done(function() {
      // load JS
      // $('body').addClass('hidetop');
      setTimeout(function(){
      var DOMContentLoaded_event = document.createEvent("Event");
      DOMContentLoaded_event.initEvent("DOMContentLoaded", true, true);
      window.document.dispatchEvent(DOMContentLoaded_event);},500);
      window.scrollTo(0,0);
      window.history.pushState(false, false, page);
    });
  }
,resizecart:function(){
    var maxh = $(window).height()-80;
    $('.ajax_place').css('max-height',maxh+"px");
    $('.mini-body').height($('#shopify-section-mini-cart').height() - $('.checkout-se').height() - 10);
    //$('#mini-cart .mini-body').css('max-height',$(window).height() - ($('.checkout-se').height() + 70 + $('.sell-note').height()));
  },

  updateCart: function () {
    var _this = this;
    $('body,html').removeClass('mini-cart-ani');
    // $.get("/cart?view=mini", function (data) {
    $.get("/?section_id=mini-cart", function (data) {

      $('#mini-cart .ajax_place').html($(data));

      var counti = $('[data-icount]').attr('data-icount');

      counti==0? $('.cart-count').text(''): $('.cart-count').text(counti);


    }).done(function (cart) {

      $('#mini-cart').removeClass('loading');
      $('body,html').addClass('mini-cart-ani');
      _this.animateCart();
    });

    setTimeout(function(){
    $('.cross-wrap').flickity({
      "pageDots": false, "contain": true, prevNextButtons: true,
    });},1000);
  },

  addItem: function (id) {
    var _this = this;

    if(!$('body').hasClass('upsell-cart'))
    {
      $('#mini-cart').addClass('loading');
      $('body,html').addClass('mini-cart');
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + 1 + "&id=" + id,
      dataType: "json",
      success: function (t) {
        if(!$('body').hasClass('upsell-cart'))
        {
          _this.updateCart();
        }else
        {
          PROJ.upsells.opencart();
          PROJ.upsells.closequickbuy();
          _this.updateCart();
        }

      },
      error: function (t, r) {
        _this.updateCart();
      }
    });
  },

  updateItem: function (id, le) {
    var _this = this;
    $('#mini-cart').addClass('loading');


    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + le + "&id=" + id,
      dataType: "json",
      success: function (t) {
        Shopify.getCart(function(cart){
          _this.updateCart();
          if($('body').hasClass('upsell-cart'))
          {
            PROJ.upsells.opencart();
          }
        }.bind(this));
      },
      error: function (t, r) {
        _this.updateCart();
      }
    });
  },


  opencart: function () {
    $('body,html').addClass('mini-cart');
    setTimeout(function(){
      $('body,html').addClass('mini-cart-ani');
    },500);
  },
  closecart: function () {
    $('body,html').removeClass('mini-cart');
    setTimeout(function(){
      $('body,html').removeClass('mini-cart-ani');
    },500);
  },
  openupsell: function () {
    $('body,html').addClass('upsell-cart-ani');
    setTimeout(function(){
      $('body,html').addClass('upsell-cart');
    },500);
  },
  closeupsell: function () {
    $('body,html').removeClass('upsell-cart');
    setTimeout(function(){
      $('body,html').removeClass('upsell-cart-ani');
    },500);
  },

  scrollbarmob: function () {
    // mobile slider
    $('.slider-bar-trigger:not(.active)').each(function(){
      var pr = $(this).parents('.slider-wrap-parent');
      var sli = pr.find('.mobile-bar');
      if(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() <= 0)
      {
        pr.find('.mobile-bar-cover').remove();
        $(this).addClass('active');
      }
    });

    $('.slider-bar-trigger:not(.active)').on('scroll',function(e){
      e.preventDefault();
      var pr = $(this).parents('.slider-wrap-parent');
      var sli = pr.find('.mobile-bar');
      var mat = $(this).attr('data-match')?parseInt($(this).attr('data-match')):0;
      sli.find('.sli').css('left',(sli.width()-sli.find('.sli').width()) * ($(this).scrollLeft()/(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() - mat )) );
      // sli.find('.sli').css('left', (-100+(92*($(this).scrollLeft()/(pr.find('.slider-bar-trigger').get(0).scrollWidth - pr.width() ))))+'%' );
    });

    $('.slider-bar-trigger').addClass('active');

    if($('.cross-scroll').length) deskmouscroll(document.querySelector('.cross-scroll'));
  },

  animateCart: function () {
    // to update and animate mini cart with total price
    var _this = this;

    $('.ns-target-gift').appendTo('.target-gifts');

    var locks = $('.target-locks .target');
    var progess_bar_val = $('.ns-progress').data('progress'); // total price

    var gifts = $('.ns-target-gift');
    for (var i = 0; i < gifts.length; i++) {
      var target = gifts.eq(i);
      if(progess_bar_val >= target.attr('data-gift-target') && target.hasClass('giftfalse') && target.hasClass('noappgift'))
      {
        _this.addItem(target.attr('data-gift-id'));
        return;
      }else if (progess_bar_val < target.attr('data-gift-target') && target.hasClass('gifttrue')  && target.hasClass('noappgift'))
      {
        _this.updateItem(target.attr('data-gift-id'),0);
        return;
      }else if (target.hasClass('multigift'))
      {
        _this.updateItem(target.attr('data-gift-id'),1);
        return;
      }
  }

    var gap = 100 / (locks.length - 1);
    var current_target;
    var next_target;
    var last_target = locks.eq(locks.length - 1);
    locks.each(function(i){
      if(progess_bar_val >= $(this).data('target'))
      {
        var element = $(this);
        current_target = $(this);
        next_target = locks.eq(i+1);
        setTimeout(function() {
          element.addClass("active");
        }, 300 * i);
      }
    });

    if(next_target) {
      if (next_target.length) {
        var extraval = (progess_bar_val - current_target.data('target')) / (next_target.data('target') - current_target.data('target'));
        var barwidth = (current_target.index() * gap) + (gap * extraval);
        $('.ns-progress-fill').width(barwidth + "%");
      } else {
        $('.ns-progress-fill').width("100%");
      }
    }




  }



};

function deskmouscroll(element)
{

  const ele = element;
  let pos = { top: 0, left: 0, x: 0, y: 0 };

  const mouseDownHandler = function(e) {
    ele.style.cursor = 'grabbing';
    ele.style.userSelect = 'none';

    pos = {
      left: ele.scrollLeft,
      x: e.clientX,
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

};
